import axios from 'axios';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies, import/extensions
import config from 'config';

const qs = require('qs');

const state = {
	notifications: '',
	poll: {
		poll: {},
	},
	polls: {
		polls: {},
	},
	allPoll: {},
};

const actions = {
	getPolls: ({ commit }, payload) => new Promise((resolve, reject) => {
		let url;
		if (payload.page && payload.results) {
			url = `${config.api}/poll?api_key=${payload.apiKey}&page=${payload.page}&results=${payload.results}`;
		} else {
			url = `${config.api}/poll?api_key=${payload.apiKey}`;
		}
		axios
			.get(url)
			.then((response) => {
				resolve(response);
				commit('setPolls', response.data, { root: true });
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.status);
			});
	}),
	getPollItem: ({ commit, rootState }, payload) => new Promise((resolve, reject) => {
		axios
			.get(`${config.api}/poll/${payload}?api_key=${rootState.apiKey}`)
			.then((response) => {
				resolve(response);
				commit('setPoll', response.data, { root: true });
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.status);
			});
	}),
	sendPoll: ({ commit, rootState }, payload) => new Promise((resolve, reject) => {
		axios({
			method: 'POST',
			url: `${config.api}/politician/${rootState.userId}/poll/${payload.pollId}/propagate?api_key=${rootState.apiKey}`,
			data: qs.stringify(payload),
		}).then((response) => {
			resolve(response);
			commit('setSuccess');
		}).catch((error) => {
			reject(error);
			commit('setError', error.response.data, { root: true });
			commit('statusCheck', error.response.status);
		});
	}),
	getPropagatePoll: ({ commit }, payload) =>
		new Promise((resolve) => {
			axios
				.get(`${config.api}/politician/${
					payload.userId
				}/poll/propagate?api_key=${payload.apiKey}`)
				.then((response) => {
					resolve(response);
					commit('setPropagatePoll', response.data);

					commit('setSuccess');
				}).then((error) => {
					commit('statusCheck', error.response.status);
				});
		}),
	setPollRegister: ({ commit, rootState }, payload) => {
		payload.status_id = 2; // eslint-disable-line camelcase
		const pollString = qs.stringify(payload);
		return new Promise((resolve, reject) => {
			axios
				.post(
					`${config.api}/register/poll/?api_key=${rootState.apiKey}`,
					pollString,
				)
				.then((response) => {
					resolve(response);
					commit('pollCreatedId', response);
					commit('setSuccess');
				})
				.catch((error) => {
					reject(error);
					commit('setError', error.response.data);
					commit('statusCheck', error.response.status);
				});
		});
	},
	editPollRegister: ({ commit, rootState }, payload) => new Promise((resolve) => {
		axios
			.put(`${config.api}/poll/${payload.poll_id}?status_id=${payload.status_id}&api_key=${rootState.apiKey}`)
			.then((response) => {
				resolve(response);
				commit('setSuccess');
			})
			.catch((error) => {
				commit('setError', error);
				commit('statusCheck', error.response.status);
			});
	}),
};

const mutations = {
	setPropagatePoll: (state, payload) => {
		state.notifications = payload;
	},
	setPolls: (state, payload) => {
		state.polls = payload;
	},
	setPoll: (state, payload) => {
		state.poll = payload;
	},
	statusCheck: (state, payload) => {
		if (payload === 403) {
			sessionStorage.setItem('statusCode', payload);
		}
	},
	getPoll: (state, payload) => {
		state.poll = payload;
	},
	getPollRegister: (state, payload) => {
		state.allPoll = payload;
	},
	pollCreatedId: (state, payload) => {
		state.poll.statusId = payload.data.id;
	},
};

const getters = {
	/* eslint-disable consistent-return */
	// genderPoll: (state) => {
	// 	if (state.overview.citizen_gender !== undefined) {
	// 		const gender = state.overview.citizen_gender;
	// 		const newObj = {
	// 			show: gender.data.reduce((a, b) => {
	// 				return a + b;
	// 			}),
	// 			name: gender.name,
	// 			select: {
	// 				labels: [gender.labels[0], gender.labels[1]],
	// 				datasets: [
	// 					{
	// 						backgroundColor: [
	// 							'rgb(174, 150, 187)',
	// 							'rgb(247, 218, 103)',
	// 						],
	// 						data: [gender.data[0], gender.data[1]],
	// 					},
	// 				],
	// 			},
	// 		};
	// 		return newObj;
	// 	}
	// },
	activePoll: (state) => {
		let activePoll = {};
		let pollSelect = {};
		if (state.allPoll.polls !== undefined) {
			activePoll = state.allPoll.polls.filter(p => p.status_id === status.active);

			if (activePoll.length > 0) {
				pollSelect = {
					show: activePoll[0].questions[0].options.reduce((a, b) => a.count + b.count),
					status_id: activePoll[0].status_id,
					id: activePoll[0].id.toString(),
					name: activePoll[0].name,
					question: activePoll[0].questions[0].content,

					active_time: activePoll[0].active_time,

					select: {
						labels: [
							activePoll[0].questions[0].options[0].content,
							activePoll[0].questions[0].options[1].content,
						],
						datasets: [
							{
								backgroundColor: [
									'rgb(174, 150, 187)',
									'rgb(247, 218, 103)',
								],
								data: [
									activePoll[0].questions[0].options[0]
										.count,
									activePoll[0].questions[0].options[1]
										.count,
								],
							},
						],
					},
				};
			}
		}
		return pollSelect;
	},

	disabledPoll: (state) => {
		let disabled = {};
		let disbabledData = {};
		if (state.allPoll.polls !== undefined) {
			disabled = state.allPoll.polls.filter(p => p.status_id === status.notActive);

			disbabledData = disabled.map((d) => {
				const newObj = {
					show: d.questions[0].options.reduce((a, b) => a.count + b.count),
					status_id: d.status_id,
					id: d.id.toString(),
					name: d.name,
					question: d.questions[0].content,
					select: {
						labels: [
							d.questions[0].options[0].content,
							d.questions[0].options[1].content,
						],
						datasets: [
							{
								backgroundColor: [
									'rgb(174, 150, 187)',
									'rgb(247, 218, 103)',
								],
								data: [
									d.questions[0].options[0].count,
									d.questions[0].options[1].count,
								],
							},
						],
					},
				};
				return newObj;
			});
			return disbabledData;
		}
	},
	filedPoll: (state) => {
		let filed = {};
		let filedData = {};
		if (state.allPoll.polls !== undefined) {
			filed = state.allPoll.polls.filter(p => p.status_id === status.filed);
			filedData = filed.map((d) => {
				const newObj = {
					show: d.questions[0].options.reduce((a, b) => a.count + b.count),
					status_id: d.status_id,
					id: d.id.toString(),
					name: d.name,
					question: d.questions[0].content,
					select: {
						labels: [
							d.questions[0].options[0].content,
							d.questions[0].options[1].content,
						],
						datasets: [
							{
								backgroundColor: [
									'rgb(174, 150, 187)',
									'rgb(247, 218, 103)',
								],
								data: [
									d.questions[0].options[0].count,
									d.questions[0].options[1].count,
								],
							},
						],
					},
				};
				return newObj;
			});
			return filedData;
		}
	},
};

export default {
	state,
	mutations,
	actions,
	getters,
};



// WEBPACK FOOTER //
// ./_source/javascripts/modules/poll/store.js